/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsAddComponent
 * Purpose		: This component allows to create new OrderDetails record and save changes.
 * Dependency	: OrderDetailsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit,
	HostBinding, trigger, transition, animate,
	style, state } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { OrderDetailsData, OrderDetailsService } from './OrderDetails.service';
import { ProductsData, ProductsService } from '../Products/Products.service';
import { OrdersData, OrdersService } from '../Orders/Orders.service';


@Component({
	selector: 'my-OrderDetails-add',
	template: require('./OrderDetailsAdd.component.html'),
	providers: [OrderDetailsService
		, ProductsService, OrdersService
		],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class OrderDetailsAddComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objOrderDetails: OrderDetailsData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	
	ProductsList: ProductsData[];
	OrdersList: OrdersData[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
	private toastr: ToastsManager,
    private OrderDetailsService: OrderDetailsService
			, private  ProductsService:  ProductsService
			, private  OrdersService:  OrdersService

	) {
		this.objOrderDetails = new OrderDetailsData();
	}

	ngOnInit() {
		this.objOrderDetails = new OrderDetailsData();
		this.getLookups();
	}

	addOrderDetails() {
		this.OrderDetailsService.addOrderDetailsData(this.objOrderDetails)
			.subscribe(record => this.router.navigate(['/OrderDetails']),
			error =>  this.errorMessage = 'There was an error while adding record. Error: ' + <any>error,
			() => { 
				this.toastr.success('OrderDetails record added successfully...', 'Add OrderDetails');
				console.log('OrderDetails record added successfully...'); 
			}
		);
	}

	gotoOrderDetails() {
		// let Id = this.objOrderDetails ? this.objOrderDetails.OrderID : null;
		this.router.navigate(['/OrderDetails']);
	}

	// Get Lookup List for Products
    getProducts() {
		this.ProductsService.getAll().subscribe(records => this.ProductsList=records);
    }
	// Get Lookup List for Orders
    getOrders() {
		this.OrdersService.getAll().subscribe(records => this.OrdersList=records);
    }

	getLookups() {

        this.getProducts();
        this.getOrders();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrderDetails/OrderDetailsAdd.component.ts